// Fix for paginated table footer since ng-table doesn't support dynamic column size
angular.module('gym.components').directive('colspanFix', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    link: function() {
      return $timeout(function() {
        var colspanValue, footer;
        colspanValue = angular.element('thead tr th').length;
        footer = angular.element('tfoot td')[0];
        return angular.element(footer).attr('colspan', colspanValue);
      });
    }
  };
}]);
